// Query-keys factory for the property module. Everything here is a read, so no
// mutation invalidates these keys today — the tree exists so the future
// admin-driven refresh (or a manual refetch) has one place to target.
export const propertyKeys = {
  all: ['property'] as const,
  lists: () => [...propertyKeys.all, 'list'] as const,
  // `page` is intentionally NOT part of the key — useInfiniteQuery manages
  // pagination via pageParam.
  list: () => [...propertyKeys.lists()] as const,
  details: () => [...propertyKeys.all, 'detail'] as const,
  detail: (id: string) => [...propertyKeys.details(), id] as const,
  portfolioStatus: () => [...propertyKeys.all, 'portfolioStatus'] as const,
}
